module.exports = __webpack_public_path__ + "img/sdg17_jp.bcaf7b19.png";